module.exports = __webpack_public_path__ + "img/building.f6bfa5e3.png";